export default {
  cols: [{
      text: "گردش بدهکار اول دوره",
      value: "opening_bed_sum",
      type: "numeric",
    },
    {
      text: "گردش بستانکار اول دوره",
      value: "opening_bes_sum",
      type: "numeric",
    },
    {
      text: "گردش بدهکار از قبل",
      value: "previous_bed_sum",
      type: "numeric",
    },
    {
      text: "گردش بستانکار از قبل",
      value: "previous_bes_sum",
      type: "numeric",
    },
    {
      text: "گردش بدهکار",
      value: "bed_sum",
      type: "numeric",
    },
    {
      text: "گردش بستانکار",
      value: "bes_sum",
      type: "numeric",
    },
    {
      text: "مانده بدهکار",
      value: "bed_remain",
      type: "numeric",
    },
    {
      text: "مانده بستانکار",
      value: "bes_remain",
      type: "numeric",
    },
    {
      text: "گردش",
      value: "ledger",
      sortable: false,
      filterable: false,
      hideInExport: true,
    },
  ],
}